import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from '../app.component';
import { BaseRouteComponent } from '../../shared/base-route.component';

@Component({
    selector: 'app-moving-seattle',
    templateUrl: './moving-seattle.component.html',
    styleUrls: ['./moving-seattle.component.css', '../blog.css'],
})
export class MovingSeattleComponent extends BaseRouteComponent {
    constructor(route: ActivatedRoute, app: AppComponent) {
        super(route, app);
    }
}



// WEBPACK FOOTER //
// /Users/masonpimentel/Repos/mason-blog/src/app/moving-seattle/moving-seattle.component.ts